import Button from 'components/Button/Button';
import './size.scss';
import useStateStore from 'services/store';
import { stepSize } from 'services/types';

const sizeInputs: {
  id: stepSize;
  label: string;
  min: number;
  max: number;
  step: number;
  unit: string;
  place: string;
}[] = [
  {
    id: 'age',
    label: 'Age',
    min: 18,
    max: 100,
    step: 1,
    unit: 'age',
    place: 'after',
  },
  {
    id: 'height',
    label: 'Height',
    min: 150,
    max: 215,
    step: 1,
    unit: 'cm',
    place: 'after',
  },
  {
    id: 'weight',
    label: 'Weight',
    min: 50,
    max: 200,
    step: 1,
    unit: 'kg',
    place: 'after',
  },
  {
    id: 'shoe-size',
    label: 'Shoe size',
    min: 6,
    max: 14,
    step: 1,
    unit: 'US',
    place: 'before',
  },
];

const Size = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeRange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    changeInforStepValues('size', e.target.value, id);
  };

  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">CREATE A SIZE FOR YOUR SHIRT</div>
        <div className="login-confirm">
          <span>Already a customer? </span>
          <Button style={{ margin: '0 0.5em', fontSize: '0.55em' }}>
            LOG IN
          </Button>
          <span>to access your sizes.</span>
        </div>
      </div>
      <form className="personal-detail-range">
        {/* <div className="input-container msm-type">
          <div className="radio-container">
            <label htmlFor="cm">Centimeters</label>
            <input checked type="radio" id="cm" name="unit" />
          </div>
          <div className="radio-container">
            <label htmlFor="cm">Inches</label>
            <input type="radio" id="inches" name="unit" />
          </div>
        </div> */}
        {sizeInputs.map((input) => {
          const { label, min, max, step, unit, place, id } = input;
          return (
            <div key={id} className="input-container">
              <div className="label-container">
                <label className="label">{label}</label>
                <span className="range-value">
                  {place === 'before'
                    ? `${unit} ${steps?.size?.[id]}`
                    : `${steps?.size?.[id]} ${unit}`}
                </span>
              </div>
              <input
                value={steps?.size?.[id]}
                onChange={(e) => handleChangeRange(e, id)}
                type="range"
                min={min}
                max={max}
                step={step}
              />
            </div>
          );
        })}
        {/* <div className="input-container">
          <div className="label-container">
            <label className="label">Age</label>
            <span className="range-value">35 age</span>
          </div>
          <input type="range" min="0" max="100" step="1" />
        </div>
        <div className="input-container">
          <div className="label-container">
            <label className="label">Height</label>
            <span className="range-value">180 cm</span>
          </div>
          <input type="range" min="0" max="100" step="1" />
        </div>
        <div className="input-container">
          <div className="label-container">
            <label className="label">Weight</label>
            <span className="range-value">85kg</span>
          </div>
          <input type="range" min="0" max="100" step="1" />
        </div>
        <div className="input-container">
          <div className="label-container">
            <label className="label">Shoe size</label>
            <span className="range-value">US 10</span>
          </div>
          <input type="range" min="0" max="100" step="1" />
        </div> */}
      </form>
    </div>
  );
};

export default Size;
